import * as React from 'react';
import { toast } from 'react-toastify';

import { Container, Grid, Spacer } from '@nextui-org/react';
import { useSession } from 'next-auth/react';
import { useStillFollowingHandlesQuery } from '@src/generated/hooks';
import { AppUnauthorized } from '@src/layouts/app/AppUnauthorized';
import { ClientsList } from '@src/layouts/clients/ClientsList';
import { StillFollowingHandles } from '@src/layouts/clients/StillFollowingHandles';
// import { UnassignedHandles } from '@src/layouts/clients/UnassignedHandles';

interface ClientsPageProps {}

// const unassignedToastId = 'toast-id-unassigned';
const stillFollowingToastId = 'toast-id-still-following';

/**
 * @name ClientsPage
 * @description The ClientsPage page.
 */
export default function ClientsPage(_props: ClientsPageProps) {
  // const { } = props;

  // Hooks
  const { status } = useSession();

  if (status === 'unauthenticated') {
    return <AppUnauthorized />;
  }

  // GraphQL
  // const { data: unassignedHandlesData } = useUnassignedHandlesQuery();
  const { data: stillFollowingHandlesData } = useStillFollowingHandlesQuery();

  // Setup
  // const unassignedHandlesCount = unassignedHandlesData?.igHandles.length ?? 0;
  // if (unassignedHandlesCount > 0) {
  //   toast.warning(<UnassignedHandles />, { toastId: unassignedToastId });
  // }

  const stillFollowingHandlesCount =
    stillFollowingHandlesData?.igHandles.length ?? 0;
  if (stillFollowingHandlesCount > 0) {
    toast.warning(<StillFollowingHandles />, {
      toastId: stillFollowingToastId,
    });
  }

  return (
    <Container sm css={{ p: 0 }}>
      <Spacer y={1} />
      <Grid.Container gap={2} css={{ p: 0 }}>
        <Grid xs={12}>
          <ClientsList />
        </Grid>
      </Grid.Container>
    </Container>
  );
}
